import { Injectable, ApplicationRef, createComponent, EnvironmentInjector, ComponentRef, EmbeddedViewRef } from '@angular/core';
import { ZignflixToasterComponent } from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  private toasterComponent?: ComponentRef<ZignflixToasterComponent>;

  constructor(
    private appRef: ApplicationRef,
    private injector: EnvironmentInjector
  ) { }

  private appendToaster() {
    if (!this.toasterComponent) {
      this.toasterComponent = createComponent(ZignflixToasterComponent, {
        environmentInjector: this.injector
      });

      this.appRef.attachView(this.toasterComponent.hostView);

      const domElem = (this.toasterComponent.hostView as EmbeddedViewRef<unknown>).rootNodes[0];
      document.body.appendChild(domElem);
    }
  }

  success(message: string) {
    this.appendToaster();
    this.toasterComponent?.instance.success(message);
  }

  error(message: string) {
    this.appendToaster();
    this.toasterComponent?.instance.error(message);
  }

  warning(message: string) {
    this.appendToaster();
    this.toasterComponent?.instance.warning(message);
  }
  
  successWithLink(message: string, linkText: string, callback: () => void) {
    this.appendToaster();
    this.toasterComponent?.instance.successWithLink(message, linkText, callback);
  }
  
  
}
